import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from './formatImage';

class HonorItem extends PureComponent {
    static propTypes = {
        img: PropTypes.string,
        name: PropTypes.string,
        rank: PropTypes.number,
        title: PropTypes.string,
        url: PropTypes.string,
        isGold: PropTypes.bool,
    };

    static staticProps = {
        isGold: false,
    };

    render() {
        const { img, name, rank, title, url, isGold } = this.props;

        return (
            <div className={styles.wp}>
                <a href={url} target="_blank" rel="noreferrer">
                    <div className={styles.title}>
                        <span>
                            {isGold && (
                                <span className={styles.rank}>
                                    第<span>{rank}</span>金
                                </span>
                            )}
                        </span>
                        <span>{name}</span>
                    </div>
                    <div className={styles.img}>
                        <img src={formatImage(img, 260, 147, 90)} alt={title} />
                        <div className={styles.text}>{title}</div>
                        <div className={styles.play}>
                            <img
                                src="https://x0.ifengimg.com/ucms/2021_29/70490BEFAE01D1C3566807199943E779B3FA3261_size3_w48_h48.png"
                                alt="播放"
                            />
                        </div>
                    </div>
                </a>
            </div>
        );
    }
}

export default HonorItem;
